module.exports = __webpack_public_path__ + "static/media/iso-error.5b80bc16.svg";